import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let reviewsSwiperWr = document.querySelectorAll('.reviews-swiper-wr');

reviewsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let buttonsEl = el.closest('.reviews-sec').querySelector('.swiper-buttons.reviews-sec__buttons');
    let nextEl = el.querySelector('.swiper-button-next') || buttonsEl.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev') || buttonsEl.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiperOptions = {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 0,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {

      },
      autoplay: {
        delay: 900000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    };

    if (paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    let swiper = new Swiper(swiperEl, swiperOptions);
    swiperObserver(swiper);
  }
});
